// extracted by mini-css-extract-plugin
export var mt0 = "fp-9U";
export var mt1 = "fp-aV";
export var mt2 = "fp-bV";
export var mt3 = "fp-cV";
export var mt4 = "fp-dV";
export var mt5 = "fp-eV";
export var mt6 = "fp-fV";
export var searchCommonTerms = "fp-gV";
export var searchCommonTerms__header = "fp-hV";
export var searchCommonTerms__item = "fp-jV";
export var searchCommonTerms__link = "fp-kV";
export var searchCommonTerms__list = "fp-iV";